// Up/down arrows side by side. Sized against the gear next to it, which only occupies the
// middle ~12px of its box - matching the copy icon's full 3-21 span made these read as bigger
// and heavier, since two bare strokes have no interior to lighten them.
export const catalogOrderingSvg = `<svg width="24" height="26" viewBox="0 0 24 26" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M9.75 18V7.5M9.75 7.5L7.75 9.5M9.75 7.5L11.75 9.5M14.25 8V18.5M14.25 18.5L12.25 16.5M14.25 18.5L16.25 16.5" stroke="#002E47" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10"/>
</svg>
`
